import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="kategorien" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-10 md:mb-14 gap-4">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-accent-600 mb-2 font-[family-name:var(--font-label)]">
              14 Sortimente
            </p>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 italic">
              Produktkategorien
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md font-[family-name:var(--font-body)]">
            Durchstöbere alle Kategorien unseres OOPBuy Spreadsheets. Jede Kategorie führt dich direkt zu den besten Angeboten.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat, index) => {
            const isLarge = index === 0 || index === 3;
            return (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className={`group relative rounded-2xl overflow-hidden bg-background-100 cursor-pointer transition-all duration-300 hover:scale-[1.02] ${
                  isLarge ? 'sm:col-span-2 sm:row-span-2' : ''
                }`}
              >
                <div className={isLarge ? 'aspect-[4/3] sm:aspect-auto sm:h-full' : 'aspect-square'}>
                  <img
                    src={cat.imageUrl}
                    alt={`OOPBuy Spreadsheet ${cat.name}`}
                    title={`${cat.name} OOPBuy Spreadsheet`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <span className="inline-block px-3 py-1 rounded-full bg-accent-500/90 text-foreground-950 text-xs font-semibold mb-2 font-[family-name:var(--font-label)]">
                    {cat.name}
                  </span>
                  <p className="text-white/90 text-xs md:text-sm font-[family-name:var(--font-body)]">
                    {cat.description}
                  </p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}